"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabIndexHandler = exports.typeMap = void 0;

var _focusableSelector = _interopRequireDefault(require("../../utils/focusable-selector"));

var _queryAll = _interopRequireDefault(require("../../utils/query-all"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Maps toast types to their classNames and icons
 */
var typeMap = {
  confirmation: {
    className: 'success',
    icon: 'fa-info-circle'
  },
  caution: {
    className: 'warning',
    icon: 'fa-warning'
  },
  'action-needed': {
    className: 'error',
    icon: 'fa-minus-circle'
  }
};
exports.typeMap = typeMap;

var tabIndexHandler = function tabIndexHandler(reset, toast) {
  if (reset) {
    // restore tab indicies that we clobbered
    return (0, _queryAll["default"])('[data-cached-tabindex]').forEach(function (el) {
      el.tabIndex = el.getAttribute('data-cached-tabindex');
    });
  }

  (0, _queryAll["default"])(_focusableSelector["default"]).filter(function (el) {
    return !toast.contains(el);
  }).forEach(function (el) {
    el.setAttribute('data-cached-tabindex', el.tabIndex);
    el.tabIndex = -1;
  });
};

exports.tabIndexHandler = tabIndexHandler;